"use client";

import React from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function AVisionOfExcellence() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const images = [{
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_private_jet_cabin_interior.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_private_jet_cabin_interior.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/luxury_private_jet_cabin_interior.png-wvc-sizes",
    alt: "Ultra-luxury private jet interior with champagne service"
  }, {
    src: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/boutique_hotel_terrace_mykonos.png",
    srcset: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/boutique_hotel_terrace_mykonos.png-wvc-srcset",
    sizes: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1687938/img/boutique_hotel_terrace_mykonos.png-wvc-sizes",
    alt: "Boutique hotel terrace overlooking the Aegean sea"
  }];
  return <section data-section-id="258833" id="a-vision-of-excellence" className="py-24 lg:py-40 bg-background text-foreground overflow-hidden relative">
      <div className="container mx-auto px-4 md:px-8">
        <div ref={ref} className={`grid grid-cols-1 lg:grid-cols-12 gap-16 lg:gap-24 items-center transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`}>
          {}
          <div className="lg:col-span-5 flex flex-col">
            <div className="space-y-8">
              <div className="inline-block">
                <span className="text-[0.75rem] font-semibold uppercase tracking-[0.3em] text-muted-foreground/80 mb-4 block">
                  Our Philosophy
                </span>
                <h1 className="text-5xl md:text-6xl lg:text-7xl font-serif text-primary leading-[1.1] tracking-tight">
                  A Vision of <br />
                  <span className="italic">Excellence</span>
                </h1>
              </div>
              
              <div className="w-20 h-px bg-[#d4af37] mb-12"></div>
              
              <div className="space-y-6 max-w-xl">
                <p className="text-lg md:text-xl text-foreground/90 font-default leading-relaxed">
                  Circuitxtravel was born from a desire to redefine luxury LGBTQ+ travel for discerning travelers worldwide. As a dedicated LGBTQ+ travel agency, we curate journeys that are not just destinations, but profound expressions of identity and celebration.
                </p>
                <p className="text-muted-foreground font-default leading-relaxed border-l-2 border-muted pl-6 italic">
                  Our philosophy is rooted in "Quiet Luxury"—where bespoke travel planning ensures a seamless experience that feels both refined and deeply welcoming.
                </p>
                <p className="text-base text-foreground/80 font-default leading-relaxed">
                  Circuitxtravel Ltd. operates as an IATA-accredited travel agency under the GoLite model, combining professional travel industry standards with personalized travel planning.
                </p>
              </div>

              <div className="pt-8">
                <Link to="/OurStoryPage">
                  <Button variant="outline" className="border-[#d4af37] text-foreground hover:bg-[#d4af37] hover:text-white rounded-md px-10 py-6 font-default tracking-[0.2em] uppercase text-[0.7rem] transition-all duration-300">
                    Discover Our Story
                  </Button>
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="lg:col-span-7 relative">
            <div className="relative aspect-[4/5] md:aspect-[16/10] lg:aspect-[4/5] w-full overflow-hidden rounded-lg shadow-2xl">
              <img data-index="0" src={images[0].src} data-wvc-srcset={images[0].srcset} data-wvc-sizes={images[0].sizes} className="w-full h-full object-cover transform hover:scale-105 transition-transform duration-700" alt={images[0].alt} loading="lazy" />
              {}
              <div className="absolute inset-0 bg-primary/5 pointer-events-none"></div>
            </div>

            {}
            <div className="absolute -bottom-12 -left-8 md:-left-16 w-1/2 md:w-2/5 aspect-square z-20 hidden sm:block">
              <div className="p-2 bg-background rounded-lg shadow-2xl">
                <img data-index="1" src={images[1].src} data-wvc-srcset={images[1].srcset} data-wvc-sizes={images[1].sizes} className="w-full h-full object-cover rounded-md" alt={images[1].alt} loading="lazy" />
              </div>
            </div>

            {}
            <div className="absolute -top-8 -right-8 w-32 h-32 border-t border-r border-[#d4af37]/30 hidden lg:block"></div>
          </div>
        </div>
      </div>
    </section>;
}